import styled from 'styled-components';
import { AMOUNT_CELL_WIDTH } from '../../constants/RepOverviewTableColumnWidths';
export default styled.td.withConfig({
  displayName: "StickyCellForecastColumn",
  componentId: "sc-2urbt6-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    '&&&': {
      textAlign: 'right',
      position: 'sticky',
      right: 0,
      width: AMOUNT_CELL_WIDTH,
      background: 'inherit',
      boxShadow: `
        inset 0 -1px 0 ${theme.color['border-primary-subtle']},
        inset -1px 0 0 ${theme.color['border-primary-subtle']}
      `,
      borderStyle: 'none !important',
      '&::before': {
        boxShadow: `-5px 0 5px -5px inset ${theme.color['border-primary-subtle']}`,
        content: '" "',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: '-5px',
        width: '5px'
      }
    }
  };
});